import { render, staticRenderFns } from "./_yesbingo.vue?vue&type=template&id=5ac585da&lang=pug&"
import script from "./_yesbingo.vue?vue&type=script&lang=js&"
export * from "./_yesbingo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports